import type { CartData, CartPositionData } from '@Types/Cart';

export const findPositionById = (positionId: string, cart: CartData): CartPositionData => {
  const positions = [...cart.removedPositions, ...cart.positions];

  return positions.find(({ id }) => positionId === id) || null;
};

export default findPositionById;
